import { render, staticRenderFns } from "./PlacementsStartComponentReviewComments.vue?vue&type=template&id=7dcc72e0&"
import script from "./PlacementsStartComponentReviewComments.vue?vue&type=script&lang=js&"
export * from "./PlacementsStartComponentReviewComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports